import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import type { FeatureValue } from '../../data/pricing';
type FeatureCellProps = {
  value: FeatureValue;
};
export function FeatureCell({
  value
}: FeatureCellProps) {
  if (value === true) {
    return <>
        <CheckIcon className="mx-auto h-5 w-5 text-red-600" strokeWidth={2.75} aria-hidden="true" data-id="element-223" data-mp="3uhnb747nesu5" />
        <span className="sr-only" data-id="element-224" data-mp="3au5po5to7jt">Included</span>
      </>;
  }
  if (value === false) {
    return <>
        <MinusIcon className="mx-auto h-4 w-4 text-gray-300" aria-hidden="true" data-id="element-225" data-mp="3pfxx1fp4pz1u" />
        <span className="sr-only" data-id="element-226" data-mp="3pi260c1vxo8z">Not included</span>
      </>;
  }
  return <span className="text-sm font-semibold text-gray-900" data-id="element-227" data-mp="3bqnns7fsxr2z">{value}</span>;
}